var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { chunk } from 'lodash';
import { PersonCell } from './person-cell';
import { ContentEntityBlock } from './content-entity-block';
import { useEntity } from '../hooks/use-entity';
export var SlicePersonGridDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n\n  "], ["\n    display: flex;\n\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var RowStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    ", ";\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    ", ";\n    &:last-child {\n      background: none;\n    }\n  "])), theme.H_DOT_BG_END('secondary')),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    flex-direction: row;\n\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    ", ";\n    flex-direction: row;\n\n    &:last-child {\n      background: none;\n    }\n  "])), theme.H_DOT_BG_END('secondary'))
});
var PersonStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    box-sizing: border-box;\n    padding: ", " 0;\n    width: 100%;\n    ", ";\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    box-sizing: border-box;\n    padding: ", " 0;\n    width: 100%;\n    ", ";\n    &:last-child {\n      background: none;\n    }\n  "])), theme.UNIT(6), theme.H_DOT_BG_END('secondary')),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    padding: ", ";\n    display: flex;\n    flex-basis: 50%;\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    ", ";\n    padding: ", ";\n    display: flex;\n    flex-basis: 50%;\n    &:last-child {\n      background: none;\n    }\n  "])), theme.V_DOT_BG_END('secondary'), theme.UNIT(8))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(ContentEntityBlock)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Row: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  Body: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Person: styled(PersonCell)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), PersonStyles)
};
export var SlicePersonGrid = function (props) {
  var className = props.className,
    children = props.children,
    rest = __rest(props, ["className", "children"]);
  var entity = useEntity(props.entity);
  var images = entity.images,
    _a = entity.people,
    people = _a === void 0 ? [] : _a;
  return React.createElement(My.Container, __assign({}, rest, {
    className: className
  }), React.createElement(My.Body, null, React.createElement(My.Content, {
    entity: entity
  }), chunk(people, 2).map(function (rowOfPeople, index) {
    return React.createElement(My.Row, {
      key: "person-row-".concat(index)
    }, rowOfPeople.map(function (person) {
      return React.createElement(My.Person, {
        key: person.id,
        entity: person
      });
    }));
  })));
};
SlicePersonGrid.defaultProps = SlicePersonGridDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;